export default () => {
  return {
    restrict: 'A',
    link: function($scope, $element, $attributes) {
      $element.draggable({
        cursor: 'hand',
        scroll: false,
        revert: function (event, ui) {
          $(this).data("uiDraggable").originalPosition = {
            top: 0,
            left: 0
          };
          return !event;
        }
      });
    }
  };
};



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/button-draggable.directive.js